import { createContext, useContext } from "react";

export type Announce = (message: string) => void;

export const AnnounceContext = createContext<Announce>(() => {});

/** Safely returns a no-op when no LiveAnnouncer provider is mounted. */
export const useAnnounce = (): Announce => useContext(AnnounceContext);
